import MeasureTool from '../../../components/map/MeasureTool.vue'
import InfoTool from '../../../components/map/info/InfoTool.vue'
import FlowTool from '../../../components/map/FlowData.vue'
import TempScaleTool from '../../../components/map/TemporalScale.vue'
import ProfileTool from '../../../components/map/ProfileViewer.vue'
import PointCloud from '../../../components/map/PointCloud.vue'
import TasksTool from '../../../components/map/TasksTool.vue'
import CommentTool from '../../../components/map/CommentTool.vue'
import ReportsBrowser from '../../../components/map/ReportsBrowser.vue'
import Permalink from '../../../components/map/Permalink.vue'
import SupportTool from '../../../components/map/SupportTool.vue'
import QaTool from '../../../components/map/QaTool.vue'
import QaInfoTool from '../../../components/map/QaTool_info.vue'
import Stats from '../../../components/projects/Stats.vue'
import Designatron from '../../../components/Designatron.vue'
import LayerControl from '../../../components/map/layers/LayerControl.vue'
import HistoryTool from '../../../components/HistoryTool'
import CloneTool from '../../../components/CloneTool'
import Scorecard from '../../../components/Scorecard'
import BowenStats from '../../../components/BowenStats'
import ProductionReport from '../../../components/westside/ProductionReport'
import Vue from 'vue'

export default {
  layers: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: LayerControl,
    w: 3,
    h: 6,
    x: 0,
    y: 0
  },
  scorecard: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: Scorecard,
    w: 6,
    h: 6,
    x: 0,
    y: 0,
    destroyable: true
  },
  history: {
    available: true,
    enabled: false,
    unlocked: false,
    clazz: HistoryTool,
    w: 8,
    h: 4,
    x: 3,
    y: 0,
    destroyable: true
  },
  bowen_stats: {
    available: true,
    enabled: false,
    unlocked: false,
    clazz: BowenStats,
    w: 8,
    h: 4,
    x: 3,
    y: 0,
    destroyable: true
  },
  westside_production: {
    available: true,
    enabled: false,
    unlocked: false,
    clazz: ProductionReport,
    w: 8,
    h: 4,
    x: 3,
    y: 0,
    destroyable: true
  },
  clone: {
    available: true,
    enabled: false,
    unlocked: false,
    clazz: CloneTool,
    w: 4,
    h: 6,
    x: 3,
    y: 0,
    destroyable: true
  },
  measure: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: MeasureTool,
    w: 3,
    h: 3,
    x: 0,
    y: 0,
    destroyable: true
  },
  flow: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: FlowTool,
    w: 5,
    h: 4,
    x: 0,
    y: 2,
    destroyable: true
  },
  comments: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: CommentTool,
    w: 4,
    h: 4,
    x: 0,
    y: 4
  },
  info: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: InfoTool,
    w: 6,
    h: 4,
    x: 3,
    y: 0,
    destroyable: true
  },
  // qa_tool: {
  //   available: true,
  //   enabled: false,
  //   unlocked: false,
  //   loading: false,
  //   clazz: QaTool,
  //   w: 5,
  //   h: 3,
  //   x: 3,
  //   y: 0,
  //   destroyable: true
  // },
  tmp_scale: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: TempScaleTool,
    w: 7,
    h: 2,
    x: 3,
    y: 4,
    maxHeight: 2
  },
  profile: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: ProfileTool
  },
  pc: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: PointCloud,
    w: 8,
    h: 5,
    x: 3,
    y: 6,
    destroyable: true,
    onDestroy: function() {
      console.log('destroying 3D widget')
      window.viewer = null
      this.$potreeService.destroy()
    }
  },
  tasks: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: TasksTool,
    w: 7,
    h: 4,
    x: 9,
    y: 0
  },
  reports: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: ReportsBrowser,
    w: 4,
    h: 3,
    x: 9,
    y: 4
  },
  permalink: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: Permalink,
    nogrid: true
  },
  support: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: SupportTool,
    w: 3,
    h: 4,
    x: 9,
    y: 8,
    destroyable: true
  },
  designotron: {
    available: true,
    enabled: false,
    unlocked: false,
    loading: false,
    clazz: Designatron,
    nogrid: true,
    w: 6,
    h: 3,
    x: 3,
    y: 11
  },
  qa_tool: {
    available: true,
    enabled: false,
    unlocked: false,
    clazz: QaTool,
    w: 4,
    h: 6,
    x: 3,
    y: 0,
    destroyable: true
  },
  qa_tool_info: {
    available: true,
    enabled: false,
    unlocked: false,
    data: {},
    gas_dest: '',
    clazz: QaInfoTool,
    w: 2,
    h: 3,
    x: 3,
    y: 0,
    destroyable: true
  },
  project_stats: {
    available: true,
    enabled: false,
    unlocked: false,
    clazz: Stats,
    w: 3,
    h: 4,
    x: 3,
    y: 0,
    destroyable: true
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/components/state.js